import {useState, useEffect} from "react";
import {useParams, useSearchParams} from "react-router-dom";
import baseUrl from "../../baseUrl";
import {requester} from "../../services/requester";
import {downloadPdf} from "../../services/downloadPdf";

// С6 — ДЗ-протоколи (общ PDF) за землище ИЛИ община (Г3 §3).
// Екранът показва какво ще влезе в PDF-а + бутон „Свали общия PDF".
// Е8: опционален филтър ?bullstat= (само протоколите на този ползвател).
export const ReportProtocols = () => {
    const {year, scopeType, scope} = useParams();
    const [searchParams] = useSearchParams();
    const bullstat = searchParams.get('bullstat');
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const request = requester();

    const query = `${scopeType}=${encodeURIComponent(scope)}`
        + (bullstat ? `&bullstat=${encodeURIComponent(bullstat)}` : '');

    useEffect(() => {
        request.get(`${baseUrl()}/reports/protocols/${year}?${query}`)
            .then(res => {
                setData(res);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [year, scopeType, scope, bullstat]);

    const handlePdf = () => {
        downloadPdf(`/reports/protocols/${year}?${query}&format=pdf`, `S6_${scope}_${year}.pdf`);
    };

    if (loading) return <div className="mt-3">Зареждане...</div>;
    if (!data) return <div className="mt-3 alert alert-warning">Няма данни.</div>;

    const scopeLabel = data.scope.type === "settlement"
        ? `Землище: ${data.scope.name}`
        : `Община: ${data.scope.name}`;

    const totalProtocols = data.sections.reduce((n, s) => n + s.rows.length, 0);

    return (
        <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h5 style={{color: "var(--app-gold)"}}>С6 — ДЗ-протоколи</h5>
                    <div>{scopeLabel}</div>
                    <div>Стопанска {data.year} година | {data.date}</div>
                    <div className="text-muted">
                        Протоколи за подпис: {totalProtocols}
                        {data.skipped_balanced > 0 &&
                            ` | взаимно погасени (пропуснати): ${data.skipped_balanced}`}
                    </div>
                </div>
                <button className="btn btn-danger" onClick={handlePdf}
                        disabled={totalProtocols === 0}>Свали общия PDF</button>
            </div>

            {totalProtocols === 0 && (
                <div className="alert alert-info">Няма протоколи за този обхват.</div>
            )}

            {data.sections.map(section => (
                <div key={section.settlement.ekatte} className="mb-4">
                    <h6 style={{color: "var(--app-gold)"}}>
                        От землище: {section.settlement.name} ({section.settlement.ekatte})
                    </h6>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                            <thead className="tableHead">
                            <tr>
                                <th>Дава</th>
                                <th>Взема</th>
                                <th>От землище</th>
                                <th>В землище</th>
                                <th className="text-end">Сума (дка)</th>
                                <th className="text-end">Обединени замени</th>
                            </tr>
                            </thead>
                            <tbody>
                            {section.rows.map((r, i) => (
                                <tr key={i}>
                                    <td>{r.company_giving}</td>
                                    <td>{r.company_receiving}</td>
                                    <td>{r.settlement_giving_name}</td>
                                    <td>{r.settlement_receiving_name}</td>
                                    <td className="text-end">{r.amount.toFixed(2)}</td>
                                    <td className="text-end">{r.count}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ))}
        </div>
    );
};
